import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserContext } from "../context/UserContext";

const Home = () => {

  const { t } = useTranslation();
  //Context user
  const { user } = useContext(UserContext)

  const [showPrehome, setShowPrehome] = useState(true)
  const prehomeRef = useRef(null)

  useEffect(() => {
    //check cookie
    const showPrehome = localStorage.getItem("prehome") === null
    setShowPrehome(showPrehome)

    if (showPrehome) {
      localStorage.setItem("prehome", "0")

      setTimeout(() => {
        prehomeRef.current.style.opacity = 0
        prehomeRef.current.addEventListener("transitionend", () => {
          setShowPrehome(false)
        })
      }, 3000)
    }
  }, []);

  return (
    <>
      {showPrehome &&
        <div id={"preHome"} ref={prehomeRef}>
          <div id={"prehomeMention"}>
            <a href={"https://www.casinosbarriere.com/jeu-responsable"} target={"_blank"}>
              <div>
                <p dangerouslySetInnerHTML={{ __html: t("home_gambling_warning") }} />
                <p dangerouslySetInnerHTML={{ __html: t("home_gambling_advice") }} />
              </div>
            </a>
          </div>
        </div>
      }
      <div id={"homeStrate1"} className={"strate"}>
        <h2 dangerouslySetInnerHTML={{ __html: t("home_title") }} />

        <p dangerouslySetInnerHTML={{ __html: t("home_subtitle1") }} />

        <p dangerouslySetInnerHTML={{ __html: t("home_subtitle2") }} />

        <div id={"ccm_wrapper"}>
          <div className={"anchor"} id={"comment-ca-marche"} />
          <h3 dangerouslySetInnerHTML={{ __html: t("home_howitworks") }} />
          <div className={"step"} id={"step1"}>
            <span>1</span>
            <div dangerouslySetInnerHTML={{ __html: t("home_howitworks_step1") }} />
          </div>
          <div className={"step"} id={"step2"}>
            <span>2</span>
            <div dangerouslySetInnerHTML={{ __html: t("home_howitworks_step2") }} />
          </div>
          <div className={"step"} id={"step3"}>
            <span>3</span>
            <div dangerouslySetInnerHTML={{ __html: t("home_howitworks_step3") }} />
          </div>
          {!user.connected &&
            <div className={"cta_wrapper"}>
              <Link className={"cta gold"} to={"/inscription"} onClick={() => window.mixpanelhandler.track("Register button_Selected", { "Result count": 1 })}>{t("home_cta_register")}</Link>
              <Link className={"cta dark"} to={"/connexion"} onClick={() => window.mixpanelhandler.track("Sign in button_Selected", { "Result count": 1 })}>{t("home_cta_login")}</Link>
            </div>
          }
        </div>

        <div id={"mention"}>
          {t("home_legal_notice")}<br /><br />
          *<a href={"/file/Règlement.pdf"} target={"_blank"} dangerouslySetInnerHTML={{ __html: t("home_legal_see_rules") }} />
        </div>
      </div>
    </>
  );
};


export default Home;
